import React from 'react';
import PageHeader from '../../components/PageHeader';

const Privacy = () => {
    const breadcrumbItems = [
        { label: 'Home', link: '/' },
        { label: 'Privacy Policy', link: '/privacy' }
    ];

    return (
        <div>
            <PageHeader items={breadcrumbItems} pageTitle="Privacy Policy" />
            <div className="container mx-auto mt-10 ml-0">
                <p className="text-md text-gray-700 mb-4">Effective Date: [Insert Date]</p>
                <p className="text-md text-gray-600 mb-4">
                    [Your Company Name] ("we," "our," or "us") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website [www.yourwebsite.com] (the
                    "Site"). Please read this privacy policy carefully. If you do not agree with the terms of this privacy policy, please do not access the site.
                </p>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">1. Information We Collect</h2>
                <p className="text-md text-gray-600 mb-4">We may collect various types of information from and about users of our website, including:</p>
                <ul className="list-disc list-inside text-md text-gray-600 mb-4">
                    <li>Personal Information: Name, email address, phone number, etc., that you provide when registering on our site, subscribing to our newsletter, or filling out a form.</li>
                    <li>Non-Personal Information: Browser type, IP address, referring site, pages visited, etc., collected automatically when you access our site.</li>
                </ul>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">2. How We Use Your Information</h2>
                <p className="text-md text-gray-600 mb-4">We may use the information we collect in the following ways:</p>
                <ul className="list-disc list-inside text-lg text-gray-700 mb-4">
                    <li>To personalize user experience and respond to your inquiries.</li>
                    <li>To improve our website based on the information and feedback we receive from you.</li>
                    <li>To send periodic emails regarding your order or other products and services.</li>
                </ul>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">3. How We Protect Your Information</h2>
                <p className="text-md text-gray-600 mb-4">We implement a variety of security measures to maintain the safety of your personal information when you enter, submit, or access your personal information.</p>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">4. Disclosure of Your Information</h2>
                <p className="text-md text-gray-600 mb-4">
                    We do not sell, trade, or otherwise transfer your personally identifiable information to outside parties. This does not include trusted third parties who assist us in operating our website, conducting our business, or servicing
                    you, so long as those parties agree to keep this information confidential.
                </p>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">5. Third-Party Links</h2>
                <p className="text-md text-gray-600 mb-4">
                    Occasionally, at our discretion, we may include or offer third-party products or services on our website. These third-party sites have separate and independent privacy policies. We, therefore, have no responsibility or liability
                    for the content and activities of these linked sites.
                </p>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">6. Your Consent</h2>
                <p className="text-md text-gray-600 mb-4">By using our site, you consent to our website privacy policy.</p>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">7. Changes to Our Privacy Policy</h2>
                <p className="text-lg text-gray-700 mb-4">If we decide to change our privacy policy, we will post those changes on this page.</p>
                <h2 className="text-2xl text-gray-600 font-semibold mb-2">8. Contacting Us</h2>
                <p className="text-lg text-gray-700 mb-4">If there are any questions regarding this privacy policy, you may contact us using the information below:</p>
                <p className="text-lg text-gray-700 mb-4">
                    <span className="font-semibold">Legal and Human Rights Center(THRC)</span>
                    <br />
                    Justice Lugakingira House,
                    <br />
                    Block 44, Plot 508/509
                    <br />
                    P. O. Box 75254, Kijitonyama
                    <br />
                    Dar es salaam, Tanzania.
                    <br />
                    Tel: +255 (0) 2773038/48
                </p>
            </div>
        </div>
    );
};

export default Privacy;
